import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolder1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconFolder1"><Path d="M2.75 3C2.33579 3 2 3.33579 2 3.75V19.25C2 19.6642 2.33579 20 2.75 20H21.25C21.6642 20 22 19.6642 22 19.25V6.75C22 6.33579 21.6642 6 21.25 6H12.4014L10.624 3.33397C10.4849 3.12533 10.2508 3 10 3H2.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolder1;
